import LocalforageIphoneFix from './LocalforageIphoneFix';

export default LocalforageIphoneFix;
